// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15l0x","largestCol":"styles_largestCol__3E_X6","smallestCol":"styles_smallestCol__2PigA"};